'use strict';

var _ = require('lodash');
var filtersConfig = require('../../filters-panel/config/FiltersPanelConfig.json');
var RomAnalysisController = function RomAnalysisController($state, $scope, $rootScope, $timeout, $filter, dataRetrieverService, dataService, constantsService, BrushSelectionFilter, analysisMetricService, featureToggleService, configurationService, optWeekReferenceService, currentStateCriteriaService) {
  var initialTopOppItem;
  var selectedFlowType = featureToggleService.isEnabled('MAPPED_MODE') ? 'REGULAR' : 'MAPPED';
  $scope.trendChart = {
    isVisible: true
  };
  $scope.selectedTopOppItem = {};
  $scope.screen = constantsService.ROM_ANALYSIS_SCREEN;
  $scope.locoMode = constantsService.ROM_ANALYSIS_LOCO_MODE;
  $scope.demandAndPaxMode = constantsService.ROM_ANALYSIS_DEMAND_PAX_MODE;
  $scope.flattenedServicesMode = constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE;
  $scope.skinnyServicesMode = constantsService.ROM_ANALYSIS_SKINNY_SERVICES_MODE;
  $scope.brushFilters = {};
  $scope.display = filtersConfig.display[0].id;
  $scope.locoFareHeatmapTitle = 'LOCO Fare (' + configurationService.getCurrencySymbol() + ')';
  var rmNumberFormat = $filter('rmNumberFormat');
  $scope.$on('filters-panel:displayChange', function (event, data) {
    $scope.display = data.id;
    $timeout(function () {
      $scope.$broadcast('rom-analysis-panel:displayChanged');
    });
  });
  $scope.$on($scope.screen + '-' + $scope.demandAndPaxMode + ':metricChanged', function () {
    $scope.$broadcast('grid:loadData:rom-demand-pax-actual-optimal');
  });
  $scope.$on('$stateChangeSuccess', function () {
    updateTopOppList();
  });
  $scope.$on('search-criteria:onSearchButtonClick', function () {
    removeTransitionData();
  });
  $scope.toggleChartVisibility = function () {
    $scope.isTrendChartVisible = !$scope.isTrendChartVisible;
  };
  $scope.onSearchChangeEvent = function () {
    dataService.clearCache();
    $scope.$broadcast('rom-analysis-panel:searchPanelClosed');
  };
  $scope.brushFilterChanged = function (filter) {
    if (!filter.isEmpty()) {
      $scope.brushFilters[filter.filterType] = filter;
    } else {
      delete $scope.brushFilters[filter.filterType];
    }
    dataRetrieverService.setBrushFilters($scope.brushFilters, $scope.screen);
    $scope.$broadcast('brush-filter:filterApplied', filter);
  };
  dataRetrieverService.updateMetricValues(analysisMetricService.getAnalysisMetric(constantsService.ROM_ANALYSIS_SCREEN).getDefault(), constantsService.ROM_ANALYSIS_SCREEN, constantsService.ROM_ANALYSIS_FLATTENED_SERVICES_MODE);
  $scope.demandPaxGridDynamicColumnsSorter = function (columns) {
    return columns.sort(function (a, b) {
      var value1 = parseInt((a.title || a).split('-')[0]);
      var value2 = parseInt((b.title || b).split('-')[0]);
      return value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
    });
  };
  $scope.canKpiRibbonLoad = function (event) {
    if (event && 'search-criteria:searchChangeEvent' === event.name) {
      return false;
    }
    var filters = dataRetrieverService.getDataRetriever(constantsService.ROM_ANALYSIS_SCREEN, $scope.skinnyServicesMode).brushFilters();
    return !(filters === undefined || filters['filter-component'] === undefined);
  };
  $scope.$on('search-criteria:searchChangeEvent', $scope.onSearchChangeEvent);
  $scope.$on('cog:romAnalysisToolbar', function (event, cogOption) {
    selectedFlowType = cogOption.val[0];
    $scope.$broadcast('rom-analysis-panel:searchPanelClosed');
  });
  $scope.getSelectedFlowType = function () {
    return selectedFlowType;
  };
  $scope.optWeekRefData = optWeekReferenceService.retrieveRomAnalysisReferenceData;
  function removeTransitionData() {
    $state.params.transitionData = null;
    updateTopOppList();
  }
  function updateTopOppList() {
    $scope.isTopOppGrid = isTopOppGrid();
    $scope.topOppListLabel = getTitleOfTopOppGrid();
    $scope.topOppList = prepareTopOppList();
    $scope.selectedTopOppItem.value = getTopOppSelectedElem();
    initialTopOppItem = _.cloneDeep($scope.selectedTopOppItem.value);
    if ($scope.isTopOppGrid) {
      dataRetrieverService.resetBrushFilters($scope.screen);
    }
  }
  function prepareTopOppList() {
    return _.map(getDataOfTopOppGrid(), function (item) {
      item.id = item.rank;
      item.label = featureToggleService.isEnabled('SPOS') ? '#' + item.rank + ' ' + item.market + ' (' + item.spos + ') Cabin ' + item.cabin + ' ' : '#' + item.rank + ' ' + item.market + ' Cabin ' + item.cabin + ' ';
      item.label += rmNumberFormat(item.value, 'NUMBER');
      return item;
    });
  }
  function getDataOfTopOppGrid() {
    function prepareElement(gridRow) {
      return {
        rank: gridRow.rank,
        market: gridRow.market,
        cabin: gridRow.cabin,
        spos: gridRow.spos,
        optGroupWeek: gridRow.optGroupWeek,
        value: _.round(gridRow.revGap, 2)
      };
    }
    if (!isTopOppGrid()) {
      return;
    }
    var sortedData = _.sortBy(getTopOppGrid().data, 'rank');
    return _.map(sortedData, prepareElement);
  }
  function getTitleOfTopOppGrid() {
    if (!isTopOppGrid()) {
      return;
    }
    if (isTopOppSpill()) {
      return 'TOP OPP Spill Rev Gaps';
    } else if (isTopOppRecap()) {
      return 'TOP OPP Recap Rev Gaps';
    } else {
      throwUnsupportedTopOppGridType();
    }
  }
  function isTopOppSpill() {
    return getGridIdOfTopOppGrid() === 'rom-summary-top-spill';
  }
  function isTopOppRecap() {
    return getGridIdOfTopOppGrid() === 'rom-summary-top-recap';
  }
  function getGridIdOfTopOppGrid() {
    if (!isTopOppGrid()) {
      return;
    }
    return getTopOppGrid().gridId;
  }
  function getTopOppSelectedElem() {
    if (!isTopOppGrid()) {
      return;
    }
    return _.find($scope.topOppList, {
      rank: getTopOppGrid().selectedRows[0].rank
    });
  }
  function isTopOppGrid() {
    return !!getTopOppGrid();
  }
  function getTopOppGrid() {
    if (!$state.params.transitionData) {
      return;
    }
    return $state.params.transitionData.topOppGrid;
  }
  function throwUnsupportedTopOppGridType() {
    throw new Error('Unsupported topOppGrid type');
  }
  $scope.onTopOppChange = function () {
    var rulesConfig = [{
      criterion: 'Market',
      field: 'market',
      category: 'Location',
      operator: '='
    }, {
      criterion: 'Opt Week',
      field: 'optGroupWeek',
      category: 'Time & Date',
      operator: '='
    }, {
      criterion: 'Cabin',
      field: 'cabin',
      category: 'Product',
      operator: '='
    }];
    if (featureToggleService.isEnabled('SPOS')) {
      rulesConfig.push({
        criterion: 'POS',
        field: 'spos',
        category: 'Location',
        operator: '='
      });
    }
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    _.forEach(rulesConfig, function (rule) {
      var currentRule = _.find(searchCriteria.rules, {
        criterion: rule.criterion
      });
      currentRule.leftOperand = [this.selectedTopOppItem.value[rule.field]];
    }.bind(this));
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.resetFilters = function () {
    if ($scope.isTopOppGrid && $scope.selectedTopOppItem.value.id !== initialTopOppItem.id) {
      $scope.selectedTopOppItem.value = _.cloneDeep(initialTopOppItem);
      $scope.onTopOppChange();
    } else {
      $scope.$broadcast('rom-analysis-panel:resetFilters');
    }
  };
};
RomAnalysisController.$inject = ['$state', '$scope', '$rootScope', '$timeout', '$filter', 'DataRetrieverService', 'DataService', 'DataRetrieverConstantsService', 'BrushSelectionFilterFactory', 'AnalysisMetricService', 'FeatureToggleService', 'ConfigurationService', 'OptWeekReferenceService', 'CurrentStateCriteriaService'];
module.exports = RomAnalysisController;